import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="block group cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className={`comic-card-hover rounded-lg overflow-hidden bg-background-100 ${isLarge ? '' : ''}`}>
        <div className={`relative overflow-hidden ${isLarge ? 'aspect-[3/4]' : 'aspect-[2/3]'}`}>
          <img
            src={comic.coverImage}
            alt={`${comic.title} - 韩国漫画免费在线阅读`}
            title={`${comic.title} - 韩国漫画`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          {comic.status === '连载中' && (
            <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-full">
              连载
            </span>
          )}
          {comic.status === '已完结' && (
            <span className="absolute top-2 left-2 px-2 py-0.5 bg-foreground-700 text-white text-xs font-medium rounded-full">
              完结
            </span>
          )}
          {comic.isHot && (
            <span className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-full">
              热门
            </span>
          )}
          {comic.isNew && !comic.isHot && (
            <span className="absolute top-2 right-2 px-2 py-0.5 bg-secondary-500 text-white text-xs font-medium rounded-full">
              新作
            </span>
          )}
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3 pt-8">
            <div className="flex items-center gap-2 text-white text-xs">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
              </span>
              <span>{comic.rating}</span>
              <span className="w-4 h-4 flex items-center justify-center ml-1">
                <i className="ri-eye-line text-xs"></i>
              </span>
              <span>{comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}</span>
            </div>
          </div>
        </div>
        <div className="p-3">
          <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
          <div className="flex flex-wrap gap-1 mt-2">
            {comic.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-1.5 py-0.5 bg-secondary-100 text-secondary-800 text-[10px] rounded"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}